import type { ReactNode } from "react";
import styles from "../ocr-health.module.css";

export function PanelCard({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <section className={styles.panel}>
      <h2 className={styles.panelTitle}>{title}</h2>
      {children}
    </section>
  );
}

export function PanelStatus({ children }: { children: ReactNode }) {
  return <div className={styles.panelStatus}>{children}</div>;
}

export function PanelError({ children }: { children: ReactNode }) {
  return <div className={styles.panelError}>{children}</div>;
}
